export default "__VITE_ASSET__BhAUCNmm__"